import type { ApolloError, DataProxy } from '@apollo/client';
import { useMutation } from '@apollo/client';

import { XcpEntityPageFollowDocument } from '../../graphql/mutations/entity-page-follow.gql-types';
import { useCompanyData } from '../use-company-data/use-company-data';
import { useError } from '../use-error';

const useFollowCompanyMutation = ({
  entityPageId,
}: {
  entityPageId: string;
}) => {
  // @ts-expect-error TS(2339) FIXME: Property 'showError' does not exist on type 'unkno... Remove this comment to see the full error message
  const { showError } = useError();
  const followCompany = useCompanyData(({ followCompany }) => followCompany);

  const [handleFollowCompany] = useMutation(XcpEntityPageFollowDocument, {
    update: (cache: DataProxy, props: any) => {
      if (props.data.entityPageFollow?.error) {
        showError({ message: props.data?.entityPageFollow?.error?.message });
      } else {
        followCompany({ entityPageId });
      }
    },
    onError: (error: ApolloError) => {
      showError({ message: error.message, error });
    },
  });

  return {
    handleFollow: () =>
      handleFollowCompany({ variables: { followedId: entityPageId } }),
  };
};

export { useFollowCompanyMutation };
